import Vue from 'vue'
import Router from 'vue-router'
import Org from './views/Attest/Index'
import orginfo from './views/Attest/orginfo'
import serveView from './views/Attest/serveView'
import serveSearch from './views/Attest/serveSearch'

import survival from './views/Attest/survival'
import Face from './views/Attest/face'
import RecordHave from './views/Attest/record'
import success from './views/Attest/success'
import error from './views/Attest/error'
import checkStatus from './views/Attest/checkStatus'
import uploadFace from './views/Attest/uploadFace'
import Headcertification from './views/Attest/Headcertification'
Vue.use(Router)
export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   redirect:'/org'      
    // },
    {
      path: '/org',
      name: 'org',
      meta: {
        title: '养老机构',
      },
      component: Org
    },

    {
      path: '/serveView',
      name: 'serveView',
      meta: {
        title: '套餐详情',
      },
      component: serveView
    },
    {
      path: '/orginfo',
      name: 'orginfo',
      meta: {
        title: '机构信息',
      },
      component: orginfo
    },
    {
      path: '/serveSearch',
      name: 'serveSearch',
      meta: {
        title: '服务查询',
      },
      component: serveSearch
    },

    {
      path: '/survival',
      name: 'survival',
      meta: {
        title: '生存认证',
      },
      component: survival
    },
    {
      path: '/face',
      name: 'face',
      meta: {
        title: '人脸识别',
      },
      component: Face
    },
    {
      path: '/record',
      name: 'record',
      meta: {
        title: '认证记录',
      },
      component: RecordHave
    },
    {
      path: '/checkStatus',
      name: 'checkStatus',
      meta: {
        title: '人脸状态',
      },
      component: checkStatus
    },
    {
      path: '/uploadFace',
      name: 'uploadFace',
      meta: {
        title: '上传人脸',
      },
      component: uploadFace
    },
    


    {
      path: '/headcertification',
      name: 'headcertification',
      meta: {
        title: '认证采集',
      },
      component: Headcertification
    },
    {
      path: '/success',
      name: 'success',
      meta: {
        title: '认证成功',
      },
      component: success
    },
    {
      path: '/error',
      name: 'error',
      meta: {
        title: '认证失败',
      },
      component: error
    },

  ]
})
